import {isString} from "./type_checking";

let fragment: Document;

function initFragment() {
    if (fragment) return;
    fragment = document.implementation.createHTMLDocument('');
    const base = fragment.createElement('base');
    base.href = document.location.href;
    fragment.head.appendChild(base);
}

function parseHTML<T extends HTMLElement>(html: string): T {
    initFragment();
    if (!isString(html)) html = '';
    fragment.body.innerHTML = html;
    return fragment.body.childNodes[0] as T;
}

export default parseHTML;